'use strict';

import { Cloudflare } from '../../../api/Cloudflare';
import { Group, LinearSRGBColorSpace, Mesh, MeshBasicMaterial } from 'three';
import { getBuildingLabel } from '../../../components/building-switch/buildingLabels';
import { CSS2DObject } from '../../../../libs/CSS2DRenderer';
import { Buildings, isMobile, projectMode } from '../../../../settings';
import { changeLangToCurrent } from '../../../components/langSwitcher/langSwitcher';

export class Neighborhood {
	#active = config.features.liteMode.settings.neighborhood?.active || false;
	#url = null;
	#loader = null;
	#group = new Group();
	#ready = false;
	#cfg = config.features.liteMode.settings.neighborhood || {};
	#labels = [];
	#activeNeighborhood = null;
	
	constructor (url,loader) {
		this.#url = `${url}${config.features.liteMode.settings.neighborhood?.path}?v=${Cloudflare.version}` || '';
		this.#loader = loader;
		
		return this;
	}
	
	create(){
		if (!this.#active) return new Promise(resolve => resolve('disabled'));
		
		return new Promise(resolve => {
			
			this.#loader.load(this.#url, model => {
				model.traverse(el => {
					if (el.isMesh) {
						const geometry = el.geometry.clone();
						const material = new MeshBasicMaterial({
							depthTest: false,
							depthWrite: false,
							transparent: true,
							opacity: 0
						});
						
						const mesh = new Mesh(geometry,material);
						mesh.name = el.name;
						mesh.scale.copy(el.scale);
						mesh.position.set(el.position.x,el.position.y, -0.2);
						mesh.rotation.copy(el.rotation);
						mesh.userData.type = 'neighborhood';
						
						if (this.#cfg.labels.active) {
							const label = this.createLabel(el.name);
							this.#labels.push(label);
							mesh.add(label);
						}
						
						this.#group.add(mesh);
					}
				});
				
				this.#group.name = 'Neighborhood';
				this.#ready = true;
				resolve(this.#group);
			});
			
		});
	}
	
	createLabel(name) {
		const labelContainer = document.createElement('div');
		labelContainer.className = 'building-labels';
		labelContainer.setAttribute('data-attribute', name);
		labelContainer.innerHTML = `
            <div class='lite-mode__building-label building-labels_wrapper ${!isMobile ? 'show-click-here' : ''}' data-name="${name}"' +
		' data-label="labelTower-${name}">
                <div class="building-label-bubble">${getBuildingLabel()}</div>
                <span class="language-string" data-dictionary="${name}">${changeLangToCurrent(name)}</span>
            </div>
            `;
		
		labelContainer.classList.add('active');
		const label = new CSS2DObject(labelContainer);
		label.name = `labelTower-${name}`;
		label.userData.name = name;
		label.userData.zoom = this.#cfg.labels.zoom;
		labelContainer.addEventListener('click',() => this.clickIntersection({name}));
		
		return label;
	}
	
	intersected(obj) {
		this.hoverOut();
		this.hoverIn(obj);
	}
	
	clickIntersection(obj) {
		const stage = obj.name;
		const buildings = Buildings.getBuildingsArray().filter(building => building.info.buildingStage === stage);
		if (buildings.length) {
			buildings.sort((a,b) => b.info.availableApartments - a.info.availableApartments);
			projectMode.Cylinder.enter(buildings[0]);
		}
	}
	
	hoverIn(obj) {
		if (obj) {
			this.#activeNeighborhood = obj;
			this.setOpacity(0.2);
			if (!isMobile) {
				const label = this.#labels.find(label => label.userData.name === obj.name);
				if (label) {
					const wrapper = label.element.querySelector('.building-labels_wrapper');
					wrapper && wrapper.classList.add('building__hovered');
				}
			}
		}
	}
	
	hoverOut() {
		if (this.#activeNeighborhood) {
			this.setOpacity(0);
			if (!isMobile) {
				const label = this.#labels.find(label => label.userData.name === this.#activeNeighborhood.name);
				if (label) {
					const wrapper = label.element.querySelector('.building-labels_wrapper');
					wrapper && wrapper.classList.remove('building__hovered');
				}
			}
			this.#activeNeighborhood = null;
		}
	}
	
	setOpacity(value) {
		this.#activeNeighborhood.material.color.setHex(0xffffff,LinearSRGBColorSpace);
		this.#activeNeighborhood.material.opacity = value;
	}
	
	switcher(state) {
		if (this.#ready) {
			switch (state) {
				case 'show':
					this.#group.visible = true;
					this.#labels.forEach(label => label.visible = true);
					break;
				case 'hide':
					this.#labels.forEach(label => label.visible = false);
					this.#group.visible = false;
					break;
			}
		}
	}
}
